import { Text } from "@alpacahq/ui/old";

import type { FAQItem } from "../../../../../components/common/FAQ";

export const AUTHORIZED_INDIVIDUAL_UBOS_FAQ: FAQItem[] = [
  {
    question: "Who is authorized to trade on the account?",
    answer: (
      <Text className="font-light text-gray-800 text-sm">
        All individuals listed in this section are authorized to trade on the
        account.
      </Text>
    ),
  },
  {
    question: "What is an Ultimate Beneficial Owner (UBO)?",
    answer: (
      <Text className="font-light text-gray-800 text-sm">
        A UBO (Ultimate Beneficial Owner) is the person who ultimately owns or
        controls a company, either directly or indirectly, usually by holding a
        significant percentage of shares or voting rights.
      </Text>
    ),
  },
  {
    question: "What if my business is a sole-proprietorship? ",
    answer: (
      <Text className="font-light text-gray-800 text-sm">
        In a sole proprietorship, the Ultimate Beneficial Owner (UBO) is the
        sole proprietor themselves since they fully own, control, and are
        personally liable for the business. There are no shareholders or
        additional owners to consider.
      </Text>
    ),
  },
  {
    question:
      "Can I add multiple Authorized Users to the business brokerage account?",
    answer: (
      <Text className="font-light text-gray-800 text-sm">
        Yes, all individuals you list in this section are authorized to trade
        and transact on the account.
      </Text>
    ),
  },
  {
    question: "How can I update the Authorized Users on my account?",
    answer: (
      <Text className="font-light text-gray-800 text-sm">
        You can write to{" "}
        <a className="underline" href="mailto:support@alpaca.markets">
          support@alpaca.markets
        </a>{" "}
        for updates to your account.
      </Text>
    ),
  },
];
